import React from "react";
import styles from "./mobileNavbar.module.css";
import { Box, Card, CardActionArea, CardContent } from "@mui/material";
import { useMenuData } from "../config";
import { DarkModeToggle } from "../darkModeToggle/darkModeToggle.component";

export const MobileNavbar = () => {
  const menuData = useMenuData();
  const currentPath = window.location.pathname.split("/")[1];

  return (
    <Box className={styles.mobileMenu}>
      <Box className={styles.menuBox}>
        {menuData.map(({ onClick, text, translatedText, icon }, index) => (
          <Card className={styles.menuCard} onClick={onClick} raised={currentPath === text.toLowerCase()}>
          <CardActionArea>
            <CardContent className={styles.menuCardContent}>
                {icon}
            </CardContent>
          </CardActionArea>
          </Card>
        ))}
        <Box className={styles.darkModeToggleBox}>
          <DarkModeToggle />
        </Box>
      </Box>
    </Box>
  );
};
